import * as React from 'react';
import { useReactFlow } from '@xyflow/react';
import { StyleSheet, css } from 'aphrodite';
import { white, borderOutline, titles, backgroundAlt, brandPrimary } from '../../../../web/styles/colors';

type ReadOnlyCanvasToolbarProps = Record<string, never>;

export const ReadOnlyCanvasToolbar: React.FC<ReadOnlyCanvasToolbarProps> = () => {
	const { zoomIn, zoomOut, fitView } = useReactFlow();

	return (
		<div className={css(styleSheet.container)}>
			<button type='button' className={css(styleSheet.button)} onClick={() => zoomIn()} title='Zoom In'>
				<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
					<path d='M8 3v10M3 8h10' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
				</svg>
			</button>

			<button type='button' className={css(styleSheet.button)} onClick={() => zoomOut()} title='Zoom Out'>
				<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
					<path d='M3 8h10' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
				</svg>
			</button>

			<button
				type='button'
				className={css(styleSheet.button)}
				onClick={() => fitView({ padding: 0.2, duration: 400 })}
				title='Fit View'
			>
				<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
					<rect x='2' y='2' width='12' height='12' rx='2' stroke='currentColor' strokeWidth='1.5' fill='none' />
					<path d='M6 8l2 2 2-2' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
				</svg>
			</button>
		</div>
	);
};

const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		padding: 8,
		backgroundColor: white,
		borderRadius: 8,
		boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
		border: `1px solid ${borderOutline}`,
	},

	button: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 6,
		padding: '6px 10px',
		fontSize: 13,
		fontWeight: 500,
		color: titles,
		backgroundColor: 'transparent',
		border: 'none',
		borderRadius: 6,
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		whiteSpace: 'nowrap',

		':hover': {
			backgroundColor: backgroundAlt,
			color: brandPrimary,
		},

		':focus': {
			outline: 'none',
			boxShadow: `0 0 0 2px ${brandPrimary}20`,
		},

		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
});
